import React from "react";
import { useSelector } from "react-redux";
import ApproveGlobal from "../../../../components/datagrid/EmployeeService/PostWorkingHours/ApproveGlobal";
import {
  approveOrRejectSaleRequest,
  getSale,
} from "../../../../redux/features/assetManagementSlice";

const ApproveRequirement = ({ saleId, dispatchParams, disable }) => {
  const { loading } = useSelector((store) => store.assetmanagement);
  return (
    <ApproveGlobal
      statusChangeApiCall={approveOrRejectSaleRequest({ saleId, status: 1 })}
      loading={loading}
      upDateCall={getSale(dispatchParams)}
      isDisabled={disable}
      buttonName={"Approve"}
    />
  );
};

export default ApproveRequirement;
